import axios from '@/load_axios';
import { API_HOST } from '@/constants';

const API_ENDPOINT = `${API_HOST}/wp-json/wp/v2/betano-mag`

const posts = {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {
    all: (state) => {
      return [...state.all]
    },
    id: (state) => (id) => {
      return state.all.find( post => post.id == id)
    },
    last: (state) => {
      const mags = [...state.all]
      return mags.sort((a, b) => b.date - a.date)[0]
    },
    latest: (state) => ({amount, offset}) => {
      let mags = []
      let skipped = 0
      for(let mag of state.all) {
        if( skipped < offset ) {
          skipped++
          continue
        }
        if( mags.length == amount ) break
        mags.push(mag)
      }
      return mags
    },
    slug: (state) => (slug) => {
      return state.all.find( post => post.slug == slug)
    },
  },
  mutations: {
    add(state, posts) {
      for(let post of posts) {
        const index = state.all.findIndex( storedPost => storedPost.id === post.id)
        if(index === -1) {
          state.all.push(post)
        } else {
          state.all.splice(index, 1, post)
        }
      }
    },
  },
    actions: {
        async getAll({commit}) {
            const res = await axios.get(API_ENDPOINT, {params: {per_page: 100}})
            console.log(res)
            commit('add', res.data)
        },
        async getOne({commit}, params) {
            const res = await axios.get(API_ENDPOINT, {params: params})
            commit('add', res.data)
            return res.data
        }
    },
}

export default posts
